import { Component, OnInit, NgZone, OnDestroy } from '@angular/core';
import { NewSignalrAlertService, Chat, ActiveUsers } from '../../../../../shared/new-signalr-alert.service';
import { NotifySignalrService } from '../../../../../shared/notify-signalr.service';
import { ToastrService } from 'ngx-toastr';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.css']
})
export class ChatComponent implements OnInit, OnDestroy {

  constructor(
    private _newSignalr: NewSignalrAlertService,
  
    private _ngZone: NgZone
    ) {
    this.subscribeToEvents();
    this.subscribeToActiveUser();
  }
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  activeEmployee: any[] = [];
  activeuserCopy: any[] = [];
  recentChat: ActiveUsers[] = [];
  tempArray: any[] = [];

  unReadedMsgs: any[] = [];



  ngOnInit() {
    this.getRecrntHistory();
  }
  txtMessage: string = '';
  senderName: string;
  tabIndex: boolean;
  namen: string;
  senderShortName: string;
  uniqueID: string = new Date().getTime().toString();
  messages = new Array<Chat>();
  message = new Chat();
  sendMessage() {
    if (this.txtMessage) {
      this.message = new Chat();
      this.message.clientuniqueid = this.uniqueID;
      this.message.userId = this.userId;
      this.message.type = "sent";
      this.message.message = this.txtMessage;
      this.message.senderName = this.senderName;
      this.message.senderShortName = this.senderShortName;
      this.message.date = new Date();
      this.messages.push(this.message);
      this._newSignalr.sendPrivateMessage(this.message);
      this.txtMessage = '';
    }
  }

  getUserId(ev: any) {
    if (ev && ev.code && !ev.AutoEmited) {
      this.userId = String(ev.code);
      this.namen = ev.nameEn;
    }
    this.getEmpMessageeHistory(ev.code);
    
    
  }
  userId: string;
  private subscribeToEvents(): void {
    this._newSignalr.privateMessage
      .subscribe((message: Chat) => {
        this._ngZone.run(() => {
         
          if (message.clientuniqueid !== this.uniqueID) {
            message.type = "received";
            if (this.userId != message.sender) {
              this.activeUsers.forEach(element => {
                if (element.empId == +message.sender) {
                  element.unreadMsg = 1;
                  this.unReadedMsgs.push({ user: message.sender, unreadMsg: 1 });
                }
              });
            } else {
              this.userId = message.sender;
              this.messages.push(message);
            }
          }
        });
      });
  }
  activeEmp: number;
  private subscribeToActiveUser(): void {
    this._newSignalr.activeUsers.subscribe((res: any) => {
      this._ngZone.run(() => {
       
        console.log(res);
        this.activeEmployee = res ? res : [];
        if (this.activeEmployee.length > 0) {
          this.activeUsers = [];
          this.activeEmployee.forEach(el => {
            let strArr = el.split(',');
            if (strArr[0] != JSON.parse(sessionStorage.getItem('currentUser')).empID) {
              this.activeUsers.push({
                empId: +strArr[0],
                userName: strArr[1],
                name: strArr[2] + ' ' + strArr[3],
                shortName: strArr[2].substr(0, 1) + strArr[3].substr(0, 1),
                unreadMsg: this.unReadedMsgs.find(el => el.user == +strArr[0]) ? this.unReadedMsgs.find(el => el.user == +strArr[0]).unreadMsg : 0
              });
              this.recentChat.forEach(elm => {
                if (elm.empId == +strArr[0]) {
                  elm.active = 1;
                }
              })
            }
            else {
              this.senderName = strArr[2] + ' ' + strArr[3];
              this.senderShortName = strArr[2].substr(0, 1) + strArr[3].substr(0, 1)

            }
          });
          this.activeuserCopy = Object.assign([], this.activeUsers);
        }
      });
    });
  }


  activeUsers: ActiveUsers[] = [];
  selectEmployee(employee: any) {
    if (employee) {
      this.userId = String(employee.empId);
      this.selectedEmp = employee;
      if (this.activeTab == 1) {
        this.activeUsers[this.activeUsers.indexOf(employee)].unreadMsg = 0;
      }
      this.getEmpMessageeHistory(employee.empId);
    }
  }

  selectedEmp: any = <any>{};
  getEmpMessageeHistory(empId: number) {
    if (empId) {
      this._newSignalr.getChatHistory(empId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          res => {
            if (res && res.data) {
              this.messages = res.data;
            }
          },
          err => console.error(err),
          () => {
            if (this.messages.length > 0) {
              this.messages.forEach(el => {
                el.recieverName = this.selectedEmp.name;
                el.recieverShortName = this.selectedEmp.shortName;
              })
            }
          });
    }
  }
  getRecrntHistory() {
    this.tabIndex = !this.tabIndex;
    this._newSignalr.getChatRecent()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        res => {
          if (res && res.data) {
            this.recentChat = res.data;
          }
        },
        err => console.error(err),
        () => { });

  }
  activeTab: number = 1;
  private ngUnsubscribe: Subject<any> = new Subject<any>();
  onsearch(value: string) {
    let exp = /^[A-Za-z][A-Za-z0-9_ ]*$/;
    if (value && value.length > 0) {
      this.activeUsers = [];

      if (exp.test(value) || value == '') {
       
        this.activeUsers = this.activeuserCopy.filter(s => s['userName'].includes(value));
      } else {
        if (isNaN(+value)) {
          this.activeUsers = this.activeuserCopy.filter(s => s['name'].includes(value));
        } else {
          this.activeUsers = this.activeuserCopy.filter(s => s['empId'] == +value);
        }
      }
    }

    if (value.length == 0) {
      this.activeUsers = this.activeuserCopy;
    }
  }
}